import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=1be5b714&scoped=true"
import script from "./create-form.vue?vue&type=script&lang=js"
export * from "./create-form.vue?vue&type=script&lang=js"
import style0 from "./create-form.vue?vue&type=style&index=0&id=1be5b714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5b714",
  null
  
)

export default component.exports